import { render } from "./OverlayLogo.vue?vue&type=template&id=3330c8a4&scoped=true"
import script from "./OverlayLogo.vue?vue&type=script&lang=js"
export * from "./OverlayLogo.vue?vue&type=script&lang=js"

import "./OverlayLogo.vue?vue&type=style&index=0&id=3330c8a4&scoped=true&lang=css"

import exportComponent from "/app/vue-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3330c8a4"]])

export default __exports__